<template>
    <main>
        <div class="row progress" style="padding:0;margin:0;">
            <div class="indeterminate"></div>
        </div>
        <navigation></navigation>
        <div class="row" style="width: 100%;margin-top:20px;">
            <div class="col s12 m4" :class="{'offset-m4':isNew}">
                <div class="card transparent" style="border-radius: 10px">
                    <form id="signup" autocomplete="off" @submit.prevent="save">
                        <div class="card-image center">
                            <img :src="img" style="border-radius: 10px 10px 0 0" />
                            <video
                                class="responsive-video"
                                controls
                                v-if="vid"
                                width="100%"
                                style="border-radius: 10px 10px 0 0"
                            >
                                <source :src="vid" type="video/mp4" />
                            </video>
                        </div>
                        <div class="card-content blue-text">
                            <!-- <span class="card-title center ">Sign Up</span> -->
                            <div class="row input-field file-field">
                                <div class="btn">
                                    <span>File</span>
                                    <input
                                        id="adFile"
                                        type="file"
                                        accept=".mp4, .jpg"
                                        @change="fileChanged"
                                    />
                                </div>
                                <div class="file-path-wrapper">
                                    <input class="file-path validate hide" type="text" />
                                    <input class="validate" v-model="form.filename" type="text" />
                                </div>
                            </div>
                            <div class="row input-field">
                                <i class="material-icons prefix">label</i>
                                <input
                                    v-model="form.label"
                                    id="label"
                                    autocomplete="off"
                                    type="text"
                                    class="validate"
                                    required
                                />
                                <label for="label">Label</label>
                            </div>
                            <div class="row input-field">
                                <i class="material-icons prefix">notes</i>
                                <input
                                    id="txt"
                                    v-model="form.txt"
                                    autocomplete="off"
                                    type="text"
                                    class="validate"
                                    required
                                />
                                <label for="txt">Text</label>
                            </div>
                            <div class="row input-field">
                                <i class="material-icons prefix">add_circle</i>
                                <input
                                    id="points"
                                    v-model="display.points"
                                    autocomplete="off"
                                    type="number"
                                    class="validate"
                                    required
                                />
                                <label for="points">Points</label>
                            </div>
                            <div class="row input-field">
                                <i class="material-icons prefix">highlight_off</i>
                                <input
                                    id="max"
                                    v-model="display.max"
                                    autocomplete="off"
                                    type="number"
                                    class="validate"
                                    required
                                />
                                <label for="max">Max Claims</label>
                            </div>
                            <div class="row input-field">
                                <i class="material-icons prefix">format_list_numbered</i>
                                <input
                                    id="priority"
                                    v-model="display.priority"
                                    autocomplete="off"
                                    type="number"
                                    class="validate"
                                    required
                                />
                                <label for="priority">Priority</label>
                            </div>
                            <div class="row input-field">
                                <i class="material-icons prefix">link</i>
                                <input
                                    id="link"
                                    v-model="form.link"
                                    autocomplete="off"
                                    type="text"
                                    class="validate"
                                    required
                                />
                                <label for="link">Link</label>
                            </div>
                            <div class="row input-field" style="margin-bottom:20px">
                            </div>
                        </div>
                        <div
                            class="row card-action center"
                            style="border-radius: 10px"
                            v-if="!form.dead"
                        >
                            <!--a class="blue-text" href="/signup">Sign Up</a-->
                            <button type="submit" class="btn right">
                                <i class="material-icons right">save</i>Save
                            </button>
                            <a class="btn-flat left" @click="del" v-if="$route.params.id">
                                <i class="material-icons">delete</i>
                            </a>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col s12 m8" v-if="!isNew">
                <ul class="collection collection with-header">
                    <li class="collection-header">
                        <div class="row valign-wrapper" style="margin:0">
                            <div class="col s6">
                                <h5>Claimants</h5>
                            </div>
                            <div class="col s6">
                                <a class="btn right" @click="download">
                                    <i class="material-icons right">cloud_download</i>Export
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="collection-item row">
                        <div class="col s12 m4">
                            <b>Timestamp</b>
                        </div>
                        <div class="col s12 m4 center">
                            <b>Phonenumber</b>
                        </div>
                        <div class="col s12 m4">
                            <span class="right">
                                <b>Points</b>
                            </span>
                        </div>
                    </li>
                    <li class="collection-item row" v-for="claim in claims" :key="claim.id">
                        <div class="col s12 m4">{{claim.timestamp | sdf}}</div>
                        <div class="col s12 m4 center">{{claim.id}}</div>
                        <div class="col s12 m4">
                            <span class="right">{{claim.points}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </main>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import "firebase/storage";
import moment from "moment";
import { mapState } from "vuex";

export default {
    data() {
        return {
            form: {
                id: this.$firebase
                    .firestore()
                    .collection("ads")
                    .doc().id,
                timestamp: new Date().getTime(),
                label: "",
                points: 0,
                txt: "",
                filename: "",
                priority: 0,
                max: 0,
                type: "picture",
                dead: false,
            },
            display: {
                points: 0,
                priority: 0,
                max: 0
            },
            filename: "",
            img: null,
            vid: null,
            file: null,
            regions: {},
            provinces: {},
            cities: {}
        };
    },
    components: { navigation},
    computed: mapState({
        isNew: function() {
            return this.$route.params.id ? false : true;
        },
        claims: function(state) {
            let values = Object.values(
                state["claims/" + this.$route.params.id]
                    ? state["claims/" + this.$route.params.id]
                    : {}
            );
            return values.sort(
                (a, b) => b.timestamp.seconds - a.timestamp.seconds
            );
        }
    }),
    watch: {
        "display.max"() {
            this.form.max = parseFloat(this.display.max);
        },
        "display.priority"() {
            this.form.priority = parseFloat(this.display.priority);
        },
        "display.points"() {
            this.form.points = parseFloat(this.display.points);
        }
    },
    mounted() {
        this.$$(".progress").hide();
        this.$M.updateTextFields();
        this.$M.Collapsible.init(document.querySelectorAll(".collapsible"), {
            accordion: false
        });
        if (this.$route.params.id) {
            console.log("Meron");
            this.form.id = this.$route.params.id;
            this.$store
                .dispatch("fetchDoc", {
                    id: this.form.id,
                    store: "ads",
                    path: "ads/" + this.form.id
                })
                .then(ad => {
                    Object.assign(this.form,ad)
                    // this.form = ad;
                    this.display = ad;
                    this.filename = this.form.filename;
                    this.$firebase
                        .storage()
                        .ref()
                        .child("public/ads/" + this.form.filename)
                        .getDownloadURL()
                        .then(url => {
                            if (this.form.type === "picture") {
                                this.img = url;
                            } else {
                                this.vid = url;
                            }
                        });
                    this.$nextTick(() => {
                        this.$M.updateTextFields();
                    });
                });
            this.$store.dispatch("fetchDB", {
                store: "claims/" + this.form.id,
                path: "ads/" + this.form.id + "/claims/",
                limit: 50
            });
        }
        else{
            console.log("Wala");
        }
    },
    methods: {
        fileChanged() {
            let input = document.querySelector("#adFile");
            let name = input.files[0].name;
            let ext =
                "." +
                input.files[0].type.substring(
                    input.files[0].type.lastIndexOf("/") + 1
                );
            if (name.lastIndexOf(".") > 0) {
                ext = name.substring(name.lastIndexOf("."));
            }
            if (input.files[0].size > 1024 * 1000 * 100) {
                this.filename = "File should not exceed 100 MB";
                this.img = null;
                this.vid = null;
                return;
            } else {
                if (input.files[0].type.includes("image")) {
                    this.vid = null;
                    this.img = window.URL.createObjectURL(input.files[0]);
                    this.form.type = "picture";
                } else {
                    this.img = null;
                    this.vid = null;
                    this.form.type = "video";
                    this.$nextTick(() => {
                        this.vid = window.URL.createObjectURL(input.files[0]);
                    });
                }
                this.filename = name;
            }
            this.form.filename = this.form.id + ext;
            this.file = input.files[0];
        },
        save() {
            this.form.timestamp = new Date().getTime();
            if (!this.$route.params.id) {
                if (!this.file || this.file.size <= 0) {
                    this.$M.toast({
                        html: "Please select a valid file to upload."
                    });
                    return;
                }
            } else {
                if (this.file && this.file.size <= 0) {
                    this.$M.toast({
                        html: "Please select a valid file to upload."
                    });
                    return;
                }
            }
            let tasks = [
                this.$firebase
                    .firestore()
                    .doc("ads/" + this.form.id)[this.$route.params.id ? "update" : "set"](this.form)
            ];
            if (!this.$route.params.id || this.file) {
                tasks.push(
                    this.$firebase
                        .storage()
                        .ref()
                        .child("public/ads/" + this.form.filename)
                        .put(this.file)
                );
            }
            this.$$(".progress").fadeIn();
            Promise.all(tasks)
                .then(() => {})
                .then(() => {
                    this.$M.toast({ html: "Ad Saved" });
                    this.$$(".progress").fadeOut();
                })
                .catch(error => {
                    this.$$(".progress").fadeOut();
                    this.$M.toast({ html: error.message });
                });
        },
        del() {
            // this.$firebase.storage().ref().child("public/ads/"+this.form.filename).delete();
            this.$$(".progress").fadeIn();
            Promise.all([
                this.$firebase
                    .firestore()
                    .doc("ads/" + this.form.id)
                    .update({ dead: true }),
                this.$firebase
                    .storage()
                    .ref()
                    .child("archive/ads/" + this.form.id + "/details.json")
                    .putString(JSON.stringify(this.form))
            ])
                .then(() => {
                    return this.$firebase
                        .firestore()
                        .collection("ads")
                        .doc(this.form.id)
                        .collection("claims")
                        .get();
                })
                .then(async docs => {
                    let batch = this.$firebase.firestore().batch();
                    if (docs.size > 0) {
                        let csv = "Timestamp,Claimant,Points";
                        let count = 0;
                        docs.forEach(async doc => {
                            let data = doc.data();
                            csv =
                                csv +
                                "\n" +
                                moment(data.timestamp.seconds).format() +
                                "," +
                                doc.id +
                                "," +
                                data.points;
                            batch.delete(doc.ref);
                            count++;
                            if (count >= 490) {
                                await batch.commit();
                                batch = this.$firebase.firestore().batch();
                            }
                        });
                        await this.$firebase
                            .storage()
                            .ref()
                            .child(
                                "archive/ads/" + this.form.id + "/claims.csv"
                            )
                            .putString(csv);
                    }
                    batch.delete(
                        this.$firebase.firestore().doc("ads/" + this.form.id)
                    );
                    return batch.commit();
                })
                .then(() => {
                    this.$M.toast({ html: "Advertisment archived" });
                })
                .catch(error => {
                    this.$$(".progress").fadeOut();
                    this.$M.toast({ html: error.message });
                })
                .finally(() => {
                    this.form.dead = true;
                    this.$$(".progress").fadeOut();
                });
        },
        download() {
            this.$$(".progress").show();
            this.$firebase
                .firestore()
                .collection("ads")
                .doc(this.form.id)
                .collection("claims")
                .get()
                .then(docs => {
                    if (docs.size > 0) {
                        let csv = "Timestamp,Claimant,Points";
                        docs.forEach(async doc => {
                            let data = doc.data();
                            csv =
                                csv +
                                "\n" +
                                moment(data.timestamp.seconds).format() +
                                "," +
                                doc.id +
                                "," +
                                data.points;
                        });
                        let blob = new Blob([csv], { type: "text/csv" });
                        let elem = window.document.createElement("a");
                        elem.href = window.URL.createObjectURL(blob);
                        elem.download =
                            (this.form.label ? this.form.label : "") +
                            " Claimants.csv";
                        document.body.appendChild(elem);
                        elem.click();
                        document.body.removeChild(elem);
                        window.URL.revokeObjectURL(elem.href);
                    }
                })
                .catch(e => {
                    this.$M.toast({ html: e.message });
                })
                .finally(() => {
                    this.$$(".progress").hide();
                });
        }
    },
    filters: {
        sdf(date) {
            return moment(date.seconds * 1000).format("DD MMM YY hh:mm A");
        }
    }
};
</script>

<style scoped>

.progress {
    position: fixed;
    top: 0;
}

.collapsible-collection-item {
    @extend .transparent, .black-text, .no-padding;
}

.collapsible-body .collapsible-header {
    @extend .row;
    margin: 0px;
}
</style>